import React, { useState, useEffect } from 'react';
import logoIcon from './assets/icon.png';
import aboutBg from './assets/about_us_bg.png';

const TeamCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const targetDate = new Date('2026-02-14T00:00:00').getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div 
      className="team-countdown-container"
      style={{
        backgroundImage: `url(${aboutBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="countdown-content">
        <img src={logoIcon} alt="Magic Moon Studios" className="countdown-logo" />
        <h2 className="countdown-title-cursive">
          Meet Our Production Team
        </h2>
        
        <p className="stay-tuned-text">Stay Tuned to See Our Production Team!</p>
        <p className="announcement-text">Members will be announced soon</p>

        <div className="countdown-timer">
          <div className="timer-box">
            <div className="timer-value">{timeLeft.days}</div>
            <div className="timer-label">DAYS</div>
          </div>
          <div className="timer-separator">:</div>
          <div className="timer-box">
            <div className="timer-value">{timeLeft.hours}</div>
            <div className="timer-label">HOURS</div>
          </div>
          <div className="timer-separator">:</div>
          <div className="timer-box">
            <div className="timer-value">{timeLeft.minutes}</div>
            <div className="timer-label">MINUTES</div>
          </div>
          <div className="timer-separator">:</div>
          <div className="timer-box">
            <div className="timer-value">{timeLeft.seconds}</div>
            <div className="timer-label">SECONDS</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamCountdown;
